// assets
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import { VerifiedUserOutlined } from '@mui/icons-material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import QrCodeOutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import SettingsPhoneOutlinedIcon from '@mui/icons-material/SettingsPhoneOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

// icons
const icons = {
  dashboard: DashboardOutlinedIcon,
  products: ViewInArOutlinedIcon,
  product_listing: LayersOutlinedIcon,
  sales_channels: StorefrontOutlinedIcon,
  fullfillment_partners: AirportShuttleOutlinedIcon,
  orders: LocalGroceryStoreOutlinedIcon,
  pricing_rules: AttachMoneyOutlinedIcon,
  inventory_sync: AutorenewOutlinedIcon,
  competitors: TrendingUpOutlinedIcon,
  integrations: LinkOutlinedIcon,
  audit_logs: SummarizeOutlinedIcon,
  user_roles: VerifiedUserOutlined,
  rmb_reviews: RateReviewOutlinedIcon,
  rmb_feedback: FeedbackOutlinedIcon,
  rmb_widgets: WidgetsOutlinedIcon,
  rmb_qrcodes: QrCodeOutlinedIcon,
  cliniko_data: CloudSyncOutlinedIcon,
  bookings: CalendarMonthOutlinedIcon,
  automation: SmsOutlinedIcon,
  cellcast_settings: SettingsPhoneOutlinedIcon,
  settings: SettingsOutlinedIcon,
  billing: CreditCardOutlinedIcon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      permission: ['dashboard.view'],
      url: '/',
      icon: icons.dashboard,
      breadcrumbs: false
    },
   
    {
      id: 'rmb-customer-reviews',
      title: 'Customer Reviews',
      type: 'item',
      permission: ['rmb.reviews.view'],
      url: '/rate-my-business/customer-reviews',
      icon: icons.rmb_reviews,
      breadcrumbs: false
    },
    {
      id: 'rmb-customer-feedback',
      title: 'Customer Feedback',
      type: 'item',
      permission: ['rmb.feedback.view'],
      url: '/rate-my-business/customer-feedback',
      icon: icons.rmb_feedback,
      breadcrumbs: false
    },
    {
      id: 'rmb-widgets',
      title: 'Widgets & Funnels',
      type: 'item',
      permission: ['rmb.widgets.view'],
      url: '/rate-my-business/widgets',
      icon: icons.rmb_widgets,
      breadcrumbs: false
    },
    {
      id: 'rmb-qr-codes',
      title: 'QR Codes',
      type: 'item',
      permission: ['rmb.qrcodes.view'],
      url: '/rate-my-business/qr-codes',
      icon: icons.rmb_qrcodes,
      breadcrumbs: false
    },
    {
      id: 'cliniko-data',
      title: 'Cliniko Data',
      type: 'item',
      permission: ['cliniko.view'],
      url: '/cliniko-data',
      icon: icons.cliniko_data,
      breadcrumbs: false
    },
    {
      id: 'bookings',
      title: 'Bookings',
      type: 'item',
      permission: ['bookings.view'],
      url: '/bookings',
      icon: icons.bookings,
      breadcrumbs: false
    },
    {
      id: 'automation-workflows',
      title: 'Automation Workflows',
      type: 'item',
      permission: ['automation.view'],
      url: '/automation-workflows',
      icon: icons.automation,
      breadcrumbs: false
    },
    
    {
      id: 'billing',
      title: 'Billing & Plans',
      type: 'item',
      permission: ['billing.view'],
      url: '/billing',
      icon: icons.billing,
      breadcrumbs: false
    },
    {
      id: 'audit',
      title: 'Audit Logs',
      type: 'item',
      permission: ['auditlogs.view'],
      url: '/audit-logs',
      icon: icons.audit_logs,
      target: true
    },
    {
      id: 'user',
      title: 'User & Roles',
      type: 'item',
      permission: ['users.view', 'users.create', 'users.update', 'users.delete', 'roles.view', 'roles.create', 'roles.update', 'roles.delete'],
      url: '/users-management',
      icon: icons.user_roles,
      target: true
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      permission: ['settings.view'],
      url: '/settings',
      icon: icons.settings,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
